import { PropsWithChildren } from 'lib-shared-types-utils';
import { MouseEventHandler } from 'react';

import { AppLink } from 'components/appLink';

export type ConversationLinkProps = {
  /** The id of the conversation to link to. */
  conversationId: string;
  /** Optional click handler on the anchor, e.g. to stop a parent card from toggling. */
  onClick?: MouseEventHandler<HTMLAnchorElement>;
} & PropsWithChildren;

export const ConversationLink = ({
  conversationId,
  children,
  onClick,
}: ConversationLinkProps): JSX.Element => (
  <AppLink
    path="/conversation/:csid"
    params={{ path: { csid: conversationId } }}
    onClick={onClick}
  >
    {children}
  </AppLink>
);
